import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/financial/big-numbers')({
  component: lazyRouteComponent(() =>
    import('../../../app/financial/big-numbers').then(m => m.BigNumbersDashboard)
  )
})
